import { forbiddenCharacters, getWebEnvConfig, UnitConvertStandard } from "./helpers";

export const toastMessages = (index: number, input?: any) => {
    switch (index) {
        case 2:
            return "مخاطب با موفقیت حذف شد.";
        case 3:
            return "خطا در دریافت کپچا.";
        case 4:
            return "کد وارد شده صحیح نمی‌باشد.";
        case 5:
            return "رمز عبور با موفقیت تغییر کرد.";
        case 6:
            return "";
        case 7:
            return "";
        case 8:
            return "نام کانال با موفقیت تغییر کرد.";
        case 9:
            return "نام کاربری با موفقیت تغییر کرد.";
        case 10:
            return "حداکثر سایز تصویر ۵ مگابایت است.";
        case 11:
            return "حجم عکس نمی‌تواند ۰ بایت باشد.";
        case 12:
            return "از فرمت‌های مجاز jpg و jpeg و png استفاده کنید.";
        case 13:
            return "تصویر پروفایل با موفقیت تغییر کرد.";
        case 14:
            return "ارتباط با سرور دچار مشکل شده است.";
        case 15:
            return "";
        case 16:
            return "";
        case 17:
            return "مخاطب با موفقیت ویرایش شد.";
        case 18:
            return "مخاطب با این نام وجود دارد.";
        case 19:
            return "مخاطب با موفقیت افزوده شد.";
        case 20:
            return `${input[0]} کپی شد`;
        case 21:
            return "مشکلی در دریافت فایل‌ها پیش‌آمده است.";
        case 22:
            return "نام پوشه را وارد کنید!";
        case 23:
            return `از حروف غیرمجاز استفاده نکنید! (${forbiddenCharacters.join(" ")})`;
        case 24:
            return `پوشه ${input[0]} با موفقیت ایجاد شد.`;
        case 25:
            return "خطا در هنگام ساخت پوشه!";
        case 26:
            return "لینک با موفقیت حذف شد.";
        case 27:
            return "لینک کپی شد.";
        case 28:
            return "خطا در کپی لینک";
        case 29:
            return "فایل‌ها حذف شدند.";
        case 30:
            return "لینک کپی شد.";
        case 31:
            return "لینک با موفقیت ایجاد شد.";
        case 32:
            return "لینک با موفقیت حذف شد.";
        case 33:
            return "لینک کپی شد.";
        case 34:
            return "لینک با موفقیت به‌روزرسانی شد.";
        case 35:
            return "عملیات حذف به بازنگری نیاز دارد.";
        case 36:
            return "مخاطب با موفقیت حذف شد.";
        case 37:
            return "حذف با موفقیت انجام شد.";
        case 38:
            return "اعلان‌ها پاک شدند.";
        case 39:
            return "";
        case 40:
            return `${input[0].length === 1 ? "نشست با موفقیت حذف شد." : "همه نشست‌ها با موفقیت حذف شدند."}`;
        case 41:
            return "خطا در دریافت کپچا.";
        case 42:
            return "";
        case 43:
            return "کد وارد شده صحیح نمی‌باشد.";
        case 44:
            return "خطا در دریافت کپچا.";
        case 45:
            return "";
        case 46:
            return "کد وارد شده صحیح نمی‌باشد.";
        case 47:
            return "کد وارد شده صحیح نمی‌باشد.";
        case 48:
            return "شماره موبایل با موفقیت ویرایش شد.";
        case 49:
            return "در حال کپی کردن ...";
        case 50:
            return `خطا در هنگام کپی‌کردن. ${input[0] ? `(کمبود حجم ${input[1] ? "در اکانت صاحب پوشه" : ""})` : ""}`;
        case 51:
            return `${input[0]} از ${input[1]} فایل کپی شدند. ${input[2] ? `(کمبود حجم ${input[3] ? "در اکانت صاحب پوشه" : ""})` : ""}`;
        case 52:
            return "فایل‌ها کپی شدند.";
        case 53:
            return "در حال کپی‌کردن ...";
        case 54:
            return `خطا در هنگام کپی‌کردن. ${input[0] ? "(کمبود حجم)" : null}`;
        case 55:
            return `${input[0]} از ${input[1]} فایل کپی شدند. ${input[2] ? "(کمبود حجم)" : null}`;
        case 56:
            return "فایل‌ها کپی شدند.";
        case 57:
            return "در حال بازگردانی ...";
        case 58:
            return "خطا در هنگام بازگردانی.";
        case 59:
            return `${input[0]} از ${input[1]} فایل بازگردانی شدند.`;
        case 60:
            return "فایل‌ها بازگردانی شدند.";
        case 61:
            return "پوشه شما فایل ندارد.";
        case 62:
            return "لطفاً برای خرید جدید، بسته فعال خود را غیرفعال نمایید.";
        case 63:
            return "لینک با موفقیت حذف شد.";
        case 64:
            return "درخواست آپلود از طریق لینک با موفقیت ایجاد شد.";
        case 65:
            return "خطا در هنگام ساخت پوشه!";
        case 66:
            return `پوشه ${input[0]} با موفقیت ایجاد شد.`;
        case 67:
            return `از حروف غیرمجاز استفاده نکنید! (${forbiddenCharacters.join(" ")})`;
        case 68:
            return "نام پوشه را وارد کنید!";
        case 69:
            return "خطا در دریافت فایل‌های شما!";
        case 70:
            return "مشکلی در دریافت فایل‌ها پیش‌آمده است.";
        case 71:
            return "مشکلی در دریافت فایل‌ها پیش‌آمده است.";
        case 72:
            return `تعداد ${input[0]} فایل از علاقه‌مندی‌ها حذف شد.`;
        case 73:
            return "با موفقیت به علاقه‌مندی‌ها اضافه شد.";
        case 74:
            return "فایل‌ها حذف شدند.";
        case 75:
            return "فایل‌ها به سطل زباله منتقل شدند.";
        case 76:
            return "خطا در هنگام انتقال فایل.";
        case 77:
            return `تعداد ${input[0]} فایل انتقال یافت.`;
        case 78:
            return "فایل با موفقیت انتقال یافت.";
        case 79:
            return "لینک با موفقیت حذف شد.";
        case 80:
            return "درخواست آپلود از طریق لینک با موفقیت ایجاد شد.";
        case 81:
            return "دسترسی عمومی حذف شد.";
        case 82:
            return "خطا در کپی لینک";
        case 83:
            return "لینک کپی شد.";
        case 84:
            return "نام با موفقیت تغییر کرد.";
        case 85:
            return `${input[0]} به اشتراک گذاشته شد.`;
        case 86:
            return `دسترسی به محتوای این ${input[0]} از کاربران گرفته شد`;
        case 87:
            return "در حال بازگردانی ...";
        case 88:
            return "خطا در هنگام بازگردانی.";
        case 89:
            return `${input[0]} از ${input[1]} فایل بازگردانی شدند.`;
        case 90:
            return "فایل‌ها بازگردانی شدند.";
        case 91:
            return "این درخواست قبلا گزارش شده است.";
        case 92:
            return "درخواست آپلود از طریق لینک با موفقیت ایجاد شد.";
        case 93:
            return `پوشه ${input[0]} با موفقیت ایجاد شد.`;
        case 94:
            return "آدرس فایل معتبر نیست !";
        case 95:
            return "شماره وارد شده از قبل در مخاطبین شما قرار دارد.";
        case 96:
            return "تنظیمات با موفقیت انجام شد.";
        case 97:
            return "کاربری با این شماره تلفن وجود دارد.";
        case 98:
            return `حجم فایل نباید بیشتر از ${UnitConvertStandard(+getWebEnvConfig("MAX_UPLOAD_FILE_SIZE")).value.toFixed(0)} ${UnitConvertStandard(+getWebEnvConfig("MAX_UPLOAD_FILE_SIZE"), "fa").unit} باشد.`;
        default:
            return "";
    }
};
